import React from "react";
import Button from "@mui/material/Button";
import { useState } from "react";
import Modal from "@mui/material/Modal";
import { getComplyAdminUrl } from "../../services/userApiService";
import {
  AppCheckbox,
  fontFamily,
  paddingAndMargin,
  screenHeaderStyle,
  UpperLowerText,
  useSharedValue,
  paginationstyle,
} from "../Constants/constants";
import {
  ConditionalPagination,
  paginationStyles,
  useDynamicRowsPerPage,
} from "../../utils/paginationUtils";
import { pythonBaseUrl } from "../../App_Settings/app_settings";
import { useHistory } from "react-router-dom";
import SearchInput from "../Constants/search_input";
import { handleFileDelete } from "../../services/deleteService";
import DeleteModal from "../Models/Delete/DeleteModal";
import { CircularProgress } from "@mui/material";
import {
  getUserIdFromLocalStorage,
  logFileProcess,
  getExcelFile,
} from "../../API_Endpoints/APIEndpoints";
import {
  DownloadExcelFile,
  DownloadXMLFile,
  formatDate,
  getAllFilesList,
} from "../../Utility/utility";
import Loader from "../../Utility/loading";
import SendingAdminModal from "../../Models/SendingAdminModal";
import "../App.css";
import W8BENApiHandler from "../SendingForms/App";
import trashIcon from "../../assets/new icons/trash.svg";
import downloadFileIcon from "../../assets/new icons/reports/download file.svg";

// Modal Styling
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "28px",
  },
};

export default function ExportFunctionality() {
  const [selectedRows, setSelectedRows] = useState(null);
  const { isMenuOpen } = useSharedValue();
  // const { searchValue } = useSharedValue();
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const columns = [
    { field: "fileName", headerName: "FILE NAME", type: "string" },
    // { field: 'entityUniqueIdentifier', headerName: 'UID', type: 'string', },
    { field: "businessUnit", headerName: "CLIENT", type: "string" },
    { field: "uploadedBy", headerName: "APPROVED BY", type: "string" },
    { field: "approvedDate", headerName: "APPROVED DATE", type: "string" },
    { field: "review", headerName: "REVIEW", type: "string" },
    { field: "actions", headerName: "XML EXCEL", type: "string" },
  ];
  const [rows, setRows] = React.useState([]);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [fileType, setFileType] = useState("");

  const openModal = (type) => {
    setFileType(type);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleDownload = () => {
    // closeModal(); // Close modal before download
    // const downloadTime = new Date();
    // localStorage.setItem('downloadTime', downloadTime);
    // if (fileType === 'xml') {
    //   window.open(`https://eformapi.complytaxforms.com/p/s/${row.fileName}.xml`, '_blank');
    // } else if (fileType === 'excel') {
    //   window.open(`https://eformapi.complytaxforms.com/p/s/${row.fileName}.xltx`, '_blank');
    // }
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [bulkDeleteIds, setBulkDeleteIds] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSendingToAdmin, setIsSendingToAdmin] = useState(false);

  const [selectedCheckboxList, setSelectedCheckboxList] = useState([]);

  const [extractedData, setExtractedData] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { defaultBusinessunit, defaultOrganization, defaultUser, formatBusinessUnitLabel } =
    useSharedValue();
  // Comply Admin access is now from UserSettings context - no need to load here

  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();
  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const { ref: scrollContainerRef, rowsPerPage: dynamicRowsPerPage } = useDynamicRowsPerPage();
  const [endIndex, setEndIndex] = useState(dynamicRowsPerPage);
  React.useEffect(() => {
    const items = JSON.parse(localStorage.getItem("ExtractedData"));
    if (items) {
      setExtractedData(items);
    }
  }, []);

  const handleReviewClick = (id, rowItem) => {
    history.push({
      pathname: "/displayExtractionView",
      state: {
        someValue: id,
        accuracyPercentage: rowItem.accuracyPercentage,
        datatable: rowItem.dataExtraction,
        dataTree: rowItem.dataVisualisation,
        row: rowItem,
        rootValue: "/export",
        iSEdit: true,
      },
    });
  };
  const getAllFiles = async () => {
    const data = await getAllFilesList(
      history,
      defaultOrganization,
      defaultBusinessunit,
      defaultUser,
      5 // Status 5: Approved - ready for export
    );
    setRows(
      data.filter(
        (row) =>
          row.approvedBy !== null &&
          row.approvedDate !== null &&
          row.reviewedDate !== null &&
          (row.fileName.toLowerCase().includes(searchValue.toLowerCase()) ||
            (row.uploadedBy || "").toLowerCase().includes(searchValue.toLowerCase()))
      )
    );
    setLoading(false);
  };
  React.useEffect(() => {
    setLoading(true);

    getAllFiles();
  }, [searchValue, defaultBusinessunit, defaultOrganization, defaultUser]);

  React.useEffect(() => {
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(dynamicRowsPerPage);
  }, [dynamicRowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setStartIndex((parseInt(newPage) - 1) * dynamicRowsPerPage);
    setEndIndex((parseInt(newPage) - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
    // Clear selections when changing pages
    setSelectedCheckboxList([]);
    setSelectedRows(null);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value);
    // updateRowNumberOfPages(newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setStartIndex(0);
    setCurrentPage(1);
    setEndIndex(newRowsPerPage);
    // Clear selections when changing page size
    setSelectedCheckboxList([]);
    setSelectedRows(null);
  };

  let totalPages = Math.ceil(
    rows.filter((item) => item.approvedBy !== null).length / dynamicRowsPerPage
  );

  // Add bulk export functions
  const handleBulkExcelDownload = async () => {
    if (selectedCheckboxList.length === 0) {
      alert("No files selected for export!");
      return;
    }

    const confirmation = window.confirm(
      `⚠ Important Information:\nYou are downloading ${selectedCheckboxList.length} Excel files to your local storage. Please delete these files later.\n\nClick 'OK' to proceed with bulk download.`
    );

    if (confirmation) {
      for (let index = 0; index < selectedCheckboxList.length; index++) {
        const fileId = selectedCheckboxList[index];
        const row = rows.find((r) => r.fileImportId === fileId);
        if (row) {
          try {
            await getExcelFile(row.organizationId, row.userID, row.businessUnit || "Demo", fileId);
          } catch (error) {
            console.error(`Error downloading Excel for ${row.fileName}:`, error);
            alert(`Failed to download Excel for ${row.fileName}. Please try again.`);
          }
          if (index < selectedCheckboxList.length - 1) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }
      }
      localStorage.setItem("downloadTime", new Date());
    }
  };

  const handleBulkXMLDownload = () => {
    if (selectedCheckboxList.length === 0) {
      alert("No files selected for export!");
      return;
    }

    const confirmation = window.confirm(
      `⚠ Important Information:\nYou are downloading ${selectedCheckboxList.length} XML files to your local storage. Please delete these files later.\n\nClick 'OK' to proceed with bulk download.`
    );

    if (confirmation) {
      selectedCheckboxList.forEach((fileId, index) => {
        const row = rows.find((r) => r.fileImportId === fileId);
        if (row) {
          // Add small delay between downloads
          setTimeout(() => {
            const formData = new FormData();
            formData.append("filename", fileId);
            formData.append("original_filename", row.fileName);
            formData.append("organization_id", row.organizationId);
            formData.append("user_id", row.userID);
            formData.append("business_unit", row.businessUnit || "Demo");
            formData.append("business_unit_admin_url", row.businessUnitAdminUrl || "");

            fetch(`${pythonBaseUrl}/Excel/DownloadXmlData`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                accept: "*/*",
              },
              body: formData,
            })
              .then((response) => response.blob())
              .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${row.fileName}.xml`;
                a.click();
                window.URL.revokeObjectURL(url);
              })
              .catch((error) => {
                console.error(`Error downloading XML for ${row.fileName}:`, error);
              });
          }, index * 500); // 500ms delay between downloads
        }
      });

      const downloadTime = new Date();
      localStorage.setItem("downloadTime", downloadTime);
    }
  };

  // Use centralized delete service
  const handleDelete = async () => {
    if (bulkDeleteIds.length > 0) {
      for (const fileImportId of bulkDeleteIds) {
        const rowToDelete = rows.find((row) => row.fileImportId === fileImportId);

        await handleFileDelete({
          fileImportId,
          fileName: rowToDelete?.fileName || "Unknown file",
          rows,
          setIsDeleting,
          getAllFiles,
          setIsPopupOpen,
        });
      }

      setBulkDeleteIds([]);
      setSelectedCheckboxList([]);
      setSelectedRows(null);
      return;
    }

    if (!selectDeletedItem) {
      return;
    }

    console.log("Deleting item:", selectDeletedItem);

    const rowToDelete = rows.find((row) => row.fileImportId === selectDeletedItem);

    await handleFileDelete({
      fileImportId: selectDeletedItem,
      fileName: rowToDelete?.fileName || "Unknown file",
      rows,
      setIsDeleting,
      getAllFiles,
      setIsPopupOpen,
    });
  };

  const getFormTypeDisplayName = (formType) => {
    if (!formType) return "";
    switch (formType.toLowerCase()) {
      case "w8imy":
        return "W-8IMY";
      case "w8bene":
        return "W-8BEN-E";
      case "w9":
        return "W-9";
      case "w8ben":
        return "W-8BEN";
      case "w8exp":
        return "W-8EXP";
      case "w8eci":
        return "W-8ECI";
      case "8233":
        return "Form 8233";
      case "form 8233":
        return "Form 8233";
      case "SELFCERT-IND":
        return "SELFCERT-IND";
      case "SELFCERT-ENT":
        return "SELFCERT-ENT";
      default:
        return null; // Return null for unrecognized form types
    }
  };

  const processFormsData = (formsDataString) => {
    try {
      // Parse the JSON string
      const formsDataArray = JSON.parse(formsDataString);

      // Get all forms data
      const allForms = formsDataArray.formsData;

      // Find ID documents from the forms data
      const idDocuments = allForms.filter((item) =>
        item.data.some((obj) => obj.documentType && obj.documentType.includes("idDocument"))
      );

      // Print all ID documents first
      console.log("📄 ID Documents List:");
      idDocuments.forEach((idDocItem, index) => {
        const idDoc = idDocItem.data.reduce((acc, obj) => ({ ...acc, ...obj }), {});
        const idDocName =
          idDoc.FirstName && idDoc.LastName
            ? `${idDoc.FirstName} ${idDoc.LastName}`
            : idDoc.LastName || idDoc.FirstName || "Unnamed ID Document";
        console.log(`  ${index + 1}. ${idDocName} (Type: ${idDoc.documentType || "Unknown"})`);
      });

      // Process each form and attach matching ID document viewPDF URL if available
      const finalArray = allForms.map((item) => {
        // Merge all objects inside `data` array into one object
        const mergedRow = item.data.reduce((acc, obj) => ({ ...acc, ...obj }), {});

        // Print form details before matching
        const formName =
          // mergedRow["Name of organization"] ||
          //       mergedRow["Beneficial Owner name"] ||
          //       mergedRow["Name of entity/individual"] ||
          mergedRow["Beneficial_owner"] ||
          mergedRow["Name of organization"] ||
          mergedRow["Beneficial Owner name"] ||
          mergedRow["IMY-Name_of_organization"] ||
          mergedRow["EXP_Organization_name"] ||
          mergedRow["W8_BENE_Organization_name"] ||
          mergedRow["BENE-organization_name"] ||
          mergedRow["W9_Entity_name"] ||
          "Unnamed Form";

        console.log(`\n🔍 Processing Form: ${formName} (Type: ${mergedRow.formType || "Unknown"})`);

        // Check if this is not an ID document itself
        if (!item.data.some((obj) => obj.documentType && obj.documentType.includes("idDocument"))) {
          // Find matching ID document by name
          const matchingIdDoc = findMatchingIdDocument(mergedRow, idDocuments);
          if (matchingIdDoc) {
            // Add the viewPDF URL to the form data
            mergedRow.idDocumentUrl = matchingIdDoc.viewPdf;
            mergedRow.idDocumentType = matchingIdDoc.documentType;
          }
        }

        return mergedRow;
      });

      return finalArray;
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  // Helper function to find matching ID document by name
  const findMatchingIdDocument = (formData, idDocuments) => {
    // Extract the person name from the form data
    const formName =
      formData["Beneficial Owner name"] ||
      formData["W8-BENE-Organization_name"] ||
      formData["Name of organization"];

    if (!formName) {
      console.log("Warning: Form has no name to match with ID document");
      return null;
    }

    // Normalize names for comparison
    const normalizeName = (name) => {
      return name
        .toLowerCase()
        .replace(/-/g, " ") // Replace hyphens with spaces
        .replace(/\s+/g, " ") // Replace multiple spaces with single space
        .trim();
    };

    const normalizedFormName = normalizeName(formName);

    // Look for matching ID document
    for (const idDocItem of idDocuments) {
      // Extract the ID document name
      const idDoc = idDocItem.data.reduce((acc, obj) => ({ ...acc, ...obj }), {});

      // Get the ID document name
      const idDocName =
        idDoc.FirstName && idDoc.LastName
          ? `${idDoc.FirstName} ${idDoc.LastName}`
          : idDoc.LastName || idDoc.FirstName || "";

      const normalizedIdDocName = normalizeName(idDocName);

      // Check for a match (case insensitive and ignoring hyphens)
      if (normalizedIdDocName === normalizedFormName) {
        console.log(`✅ Exact Match found: 
          Form Name: ${formName}
          ID Document Name: ${idDocName}
          Form Type: ${formData.formType || "Unknown"}
          ID Document Type: ${idDoc.documentType || "Unknown"}`);
        return idDoc;
      }

      // Check for partial match (first name or last name)
      const formNameParts = normalizedFormName.split(" ");
      const idDocNameParts = normalizedIdDocName.split(" ");

      const hasMatchingPart = formNameParts.some((part) => idDocNameParts.includes(part));

      if (hasMatchingPart) {
        console.log(`⚠️ Partial Match found: 
          Form Name: ${formName}
          ID Document Name: ${idDocName}
          Form Type: ${formData.formType || "Unknown"}
          ID Document Type: ${idDoc.documentType || "Unknown"}`);
        return idDoc;
      }
    }

    console.log(`❌ No matching ID document found for form: ${formName}`);
    return null;
  };

  // Update the handleSendAdmin function to include the ID document logic
  const handleSendAdmin = async () => {
    if (!selectedRows) {
      alert("No file selected!");
      return;
    }

    if (!String(selectedRows.businessUnitAdminUrl || "").trim()) {
      alert(
        `Cannot send to Admin. Add an Admin URL for business unit "${selectedRows.businessUnit || "Unknown business unit"}" in Settings > Clients.`
      );
      return;
    }

    setIsSendingToAdmin(true); // Start loading

    const formData = new FormData();
    formData.append("filename", selectedRows.fileImportId);
    formData.append("organization_id", selectedRows.organizationId);
    formData.append("user_id", selectedRows.userID);
    formData.append("business_unit", selectedRows.businessUnit || "Demo");
    formData.append("business_unit_admin_url", selectedRows.businessUnitAdminUrl || "");

    const url = `${pythonBaseUrl}/Excel/DownloadXmlData`;

    try {
      // Wait for the API call to complete
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          accept: "*/*",
        },
        body: formData,
      });

      // Check if the response is successful
      if (!response.ok) {
        throw new Error(`API call failed with status: ${response.status}`);
      }

      // Log the file process after successful API call
      logFileProcess({
        fileImportId: selectedRows.fileImportId,
        fileName: selectedRows.fileName,
        exportedDate: new Date(),
      });

      // XML sent successfully — send all forms in parallel before opening the admin URL
      let formsSent = 0;
      let formsFailed = 0;

      if (selectedRows.formsData) {
        const newData = processFormsData(selectedRows.formsData) || [];
        const withholdingStatementUrl = `${selectedRows.organizationId}/${selectedRows.userID}/${selectedRows.businessUnit}/split_documents/${selectedRows.fileImportId}/Withholding Statement.pdf`;

        if (newData.length > 0) {
          let isFirstForm = true;
          const formSubmissions = [];
          for (const item of newData) {
            if (item.documentType && item.documentType.includes("idDocument")) continue;
            const formTypeDisplay = getFormTypeDisplayName(item.formType);
            if (!formTypeDisplay) continue;
            if (isFirstForm) {
              item.withholdingStatementUrl = withholdingStatementUrl;
              isFirstForm = false;
            }
            formSubmissions.push(
              W8BENApiHandler({
                formData: {
                  ...item,
                  businessUnit: selectedRows.businessUnit,
                  businessUnitAdminUrl: selectedRows.businessUnitAdminUrl,
                },
                formType: formTypeDisplay,
                idDocumentUrl: item.idDocumentUrl,
                idDocumentType: item.idDocumentType,
              })
                .then(() => ({ success: true }))
                .catch((formError) => {
                  console.error(`Error sending form ${formTypeDisplay}:`, formError);
                  return { success: false };
                })
            );
          }

          // Wait for every form submission to finish (in parallel) before proceeding
          const results = await Promise.all(formSubmissions);
          formsSent = results.filter((r) => r.success).length;
          formsFailed = results.filter((r) => !r.success).length;

          const formMessage =
            formsFailed > 0
              ? `${formsSent} form(s) sent to Admin successfully. ${formsFailed} form(s) failed.`
              : `${formsSent} form(s) sent to Admin successfully.`;
          alert(formMessage);
        }
      }

      // Only open the admin URL once the XML call and all form submissions have completed
      if (formsFailed === 0) {
        const orgAdminUrl = await getComplyAdminUrl();
        const adminUrl = orgAdminUrl || selectedRows.businessUnitAdminUrl;
        const newUrl = `${adminUrl}/Pages/Import/eFrontdata.aspx?fileName=${encodeURIComponent(selectedRows.fileImportId)}`;
        window.open(newUrl, "ImportSystem");
      }
    } catch (error) {
      console.error("Error in handleSendAdmin:", error);
      alert("Failed to process the request. Please try again.");
    } finally {
      setIsSendingToAdmin(false); // Stop loading
    }
  };

  const handleSalectingCheckBox = (isChecked, row) => {
    if (isChecked) {
      setSelectedRows(row);
      setSelectedCheckboxList((prev) =>
        prev.includes(row.fileImportId) ? prev : [...prev, row.fileImportId]
      );
    } else {
      if (selectedRows !== null && selectedRows.fileImportId === row.fileImportId) {
        setSelectedRows(null);
      }
      setSelectedCheckboxList((prev) => prev.filter((id) => id !== row.fileImportId));
    }
  };

  const handleColumnCheckboxChange = (e) => {
    if (e.target.checked) {
      // Select all rows in the current page for bulk export
      const selectedInRange = rows
        .filter((item) => item.approvedBy !== null)
        .slice(startIndex, endIndex)
        .map((row) => row.fileImportId);

      setSelectedCheckboxList(selectedInRange);
      // Clear single selection when selecting column checkbox
      setSelectedRows(null);
    } else {
      // Deselect all rows
      setSelectedCheckboxList([]);
    }
  };

  const handleBulkDeleteClick = () => {
    if (selectedCheckboxList.length <= 1) {
      return;
    }

    setBulkDeleteIds(selectedCheckboxList);
    setSelectDeletedItem(null);
    setIsPopupOpen(true);
  };
  return (
    <>
      <div id="extraction_Review" className={screenHeaderStyle(isMenuOpen)}>
        {/* Loading overlay during deletion */}
        {isDeleting && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              zIndex: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "none",
              }}
            >
              <CircularProgress size={24} style={{ color: "var(--loader-color)" }} />
              <span style={{ fontFamily: fontFamily, fontSize: "14px" }}>Deleting file...</span>
            </div>
          </div>
        )}
        {/* Loading overlay during send to admin */}
        <SendingAdminModal isOpen={isSendingToAdmin} fontFamily={fontFamily} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
            marginTop: paddingAndMargin.headerTopHeight,
            marginBottom: paddingAndMargin.headerBelowHeight,
          }}
        >
          <SearchInput
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            onClick={() => {
              setSearchValue("");
            }}
          />

          {/* Rows per page dropdown - next to search box */}
          {/* {rows.filter((item) => item.approvedBy !== null).length > numberOfSelectedRows && (
          <div
            style={{ display: "flex", alignItems: "center", marginLeft: 10, marginRight: "auto" }}
          >
            <label
              style={{
                fontFamily: fontFamily,
                fontWeight: 400,
                fontSize: 12,
                color: "#333",
              }}
            >
              Displayed per page:&nbsp;
              <select
                className="pagination-select"
                value={numberOfSelectedRows}
                onChange={handleRowsPerPageChange}
              >
                {[5, 10, 15, 20, 25, 30].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )} */}

          {/* Bulk Export Buttons + Single Actions */}
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {selectedCheckboxList.length > 1 && (
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  className="review-btn-filled"
                  onClick={handleBulkExcelDownload}
                >
                  Export Excel ({selectedCheckboxList.length})
                </Button>
                <Button
                  variant="contained"
                  className="review-btn-filled"
                  onClick={handleBulkXMLDownload}
                >
                  Export XML ({selectedCheckboxList.length})
                </Button>
                <Button
                  variant="contained"
                  className="review-btn-outline"
                  onClick={handleBulkDeleteClick}
                >
                  Delete ({selectedCheckboxList.length})
                </Button>
              </div>
            )}
            {/* Adjusting button styles as per requirements */}
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {selectedCheckboxList.length <= 1 && (
                <Button
                  variant="contained"
                  className="review-btn-outline"
                  onClick={() => {
                    if (!selectedRows) {
                      alert("No file selected!");
                      return;
                    }
                    setBulkDeleteIds([]);
                    setIsPopupOpen(true);
                    setSelectDeletedItem(selectedRows.fileImportId);
                  }}
                >
                  Delete
                </Button>
              )}
              {selectedCheckboxList.length <= 1 && (
                <Button
                  variant="contained"
                  className="review-btn-filled"
                  onClick={() => {
                    handleSendAdmin();
                  }}
                  disabled={isSendingToAdmin}
                >
                  {isSendingToAdmin ? "Sending..." : "Send To Admin"}
                </Button>
              )}
            </div>
          </div>
        </div>
        {/* Main container for table with fixed height */}
        <div
          style={{
            height: "calc(100vh - 220px)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Fixed Table Header */}
          <div class="columntitlesRowStyle">
            <div>
              <AppCheckbox
                header
                onChange={handleColumnCheckboxChange}
                checked={
                  rows.filter((item) => item.approvedBy !== null).slice(startIndex, endIndex)
                    .length > 0 &&
                  rows
                    .filter((item) => item.approvedBy !== null)
                    .slice(startIndex, endIndex)
                    .every((row) => selectedCheckboxList.includes(row.fileImportId))
                }
                indeterminate={
                  selectedCheckboxList.length > 0 &&
                  !rows
                    .filter((item) => item.approvedBy !== null)
                    .slice(startIndex, endIndex)
                    .every((row) => selectedCheckboxList.includes(row.fileImportId))
                }
              />
            </div>
            {columns.map((column) => (
              <div
                key={column.field}
                class="columntitlesStyle"
                style={
                  column.field === "actions" ? { display: "flex", justifyContent: "flex-end" } : {}
                }
              >
                {column.field === "actions" ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 12,
                      paddingRight: 20,
                    }}
                  >
                    <span style={{ textAlign: "center" }}>XML</span>
                    <span style={{ textAlign: "center" }}>Excel</span>
                    <span />
                  </div>
                ) : (
                  <UpperLowerText text={column.headerName} />
                )}
              </div>
            ))}
          </div>
          {/* Main container for table with fixed height */}
          {/* <div style={{ height: "calc(100vh - 220px)", display: "flex", flexDirection: "column" }}>
        
          <div style={{ flexShrink: 0 }}></div> */}

          {/* Scrollable rows container */}
          <div ref={scrollContainerRef} style={{ flex: 1, overflowY: "auto" }}>
            {loading ? (
              <>
                {/* <CircularProgress /> */}
                <Loader />
              </>
            ) : rows.length === 0 ? (
              <div className="no-record">There are no records available.</div>
            ) : (
              <div>
                {rows
                  .filter((item) => item.approvedBy !== null)
                  .slice(startIndex, endIndex)
                  .map((row, indexValue) => (
                    <div style={{ flexDirection: "column" }}>
                      <div key={row.fileImportId} class="columnRowStyle">
                        <div>
                          <AppCheckbox
                            onChange={(event) => {
                              handleSalectingCheckBox(event.target.checked, row);
                            }}
                            checked={
                              (selectedRows !== null &&
                                selectedRows.fileImportId === row.fileImportId) ||
                              selectedCheckboxList.includes(row.fileImportId)
                            }
                          />
                        </div>
                        {columns.map((column) => (
                          <div
                            title={
                              column.headerName === "APPROVED DATE"
                                ? formatDate(row[column.field])
                                : column.field === "businessUnit" && formatBusinessUnitLabel
                                  ? formatBusinessUnitLabel(row)
                                  : row[column.field]
                            }
                            key={column.field}
                            class="columnValuesStyle"
                            // style={columnValuesStyle}
                          >
                            {column.field === "review" && (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => handleReviewClick(row.fileImportId, row)}
                              >
                                <span
                                  className="action-link"
                                  style={{
                                    flex: 1,
                                    // textAlign: 'left',
                                    fontFamily: fontFamily, // Add this line
                                    fontWeight: 300,
                                    fontSize: 14,
                                    textOverflow: "ellipsis",
                                    textTransform: "none",
                                  }}
                                >
                                  Review
                                </span>
                              </div>
                            )}
                            {column.field === "actions" && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  gap: 12,
                                }}
                              >
                                <DownloadXMLFile
                                  fileName={row.fileName}
                                  fileImportId={row.fileImportId}
                                  businessunit={row.businessUnit}
                                  businessUnitAdminUrl={row.businessUnitAdminUrl}
                                  userId={row.userID}
                                  organizationId={row.organizationId}
                                  iconSrc={downloadFileIcon}
                                  iconFilter="var(--icon-download-filter)"
                                />
                                <DownloadExcelFile
                                  fileName={row.fileImportId}
                                  businessunit={row.businessUnit}
                                  userId={row.userID}
                                  organizationId={row.organizationId}
                                  iconSrc={downloadFileIcon}
                                  iconFilter="var(--icon-download-filter)"
                                />
                                <img
                                  src={trashIcon}
                                  alt="Delete"
                                  title="Delete"
                                  onClick={() => {
                                    setBulkDeleteIds([]);
                                    setIsPopupOpen(true);
                                    setSelectDeletedItem(row.fileImportId);
                                  }}
                                  style={{
                                    width: 20,
                                    height: 20,
                                    cursor: "pointer",
                                    filter: "var(--icon-delete-filter)",
                                  }}
                                />
                              </div>
                            )}
                            {column.headerName === "APPROVED DATE" ? (
                              formatDate(row[column.field])
                            ) : !["review", "actions"].includes(column.field) ? (
                              column.field === "businessUnit" ? (
                                formatBusinessUnitLabel ? (
                                  formatBusinessUnitLabel(row)
                                ) : (
                                  row[column.field]
                                )
                              ) : column.field === "fileName" ? (
                                <span
                                  style={{
                                    color: "#101828",
                                    textTransform: "uppercase",
                                    fontWeight: 400,
                                  }}
                                >
                                  {row[column.field]}
                                </span>
                              ) : (
                                row[column.field]
                              )
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>{" "}
        <DeleteModal
          open={isPopupOpen}
          isDeleting={isDeleting}
          onClose={() => {
            setIsPopupOpen(false);
            setBulkDeleteIds([]);
          }}
          onDelete={handleDelete}
        />
        <Modal
          isOpen={modalIsOpen && fileType === "xml"}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Important Information"
        >
          <div>
            <p>⚠ Important Information:</p>
            <p>You are downloading XML to your local storage.</p>
            <p>Please delete this file later.</p>
            <button onClick={handleDownload}>OK</button>
            <button onClick={closeModal} className="cancel-btn-filled">
              Cancel
            </button>
          </div>
        </Modal>
      </div>
      <ConditionalPagination
        itemCount={rows.filter((item) => item.approvedBy !== null).length}
        itemsPerPage={dynamicRowsPerPage}
        threshold={dynamicRowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: paginationstyle,
          sx: paginationStyles,
          hidePrevButton: false,
          hideNextButton: false,
          showFirstButton: true,
          showLastButton: true,
        }}
      />
    </>
  );
}
